module.exports = __webpack_public_path__ + "img/icono_telefono.66cea031.png";